import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class UtilityService {

	constructor() { }

	/**
	 * Creates a deep copy of an object using JSON serialization
	 * @param data The object to copy
	 * @returns A deep copy of the object
	 */
	deepCopy(data: any): any {
		if (data === null || data === undefined) {
			return data;
		}
		return JSON.parse(JSON.stringify(data));
	}

	/**
	 * Recursively removes specified properties from an object or array
	 * @param obj The object or array to modify
	 * @param keys Array of property keys to remove
	 */
	removeProps(obj: any, keys: string[]): void {
		if (Array.isArray(obj)) {
			obj.forEach(item => {
				this.removeProps(item, keys);
			});
		} else if (typeof obj === 'object' && obj != null) {
			Object.getOwnPropertyNames(obj).forEach(key => {
				if (keys.indexOf(key) !== -1) {
					delete obj[key];
				} else {
					this.removeProps(obj[key], keys);
				}
			});
		}
	}

	/**
	 * Creates a deep copy of an object and removes base64-encoded data
	 * @param obj The object to copy and sanitize
	 * @returns A new object without base64-encoded data
	 */
	copyAndRemoveBase64Data(obj: any): any {
		let copy = this.deepCopy(obj);
		try {
			this.removeProps(copy, ['base64EncodedData', 'base64EncodedSignature']);
		} catch (error) {
      console.warn('Failed to sanitize base64 data:', error);
    }
		return copy;
	}
}
